type Props = {
  className?: string
}

const CartIcon = ({ className = 'h-5 w-5' }: Props) => (
  <svg aria-hidden viewBox="0 0 24 24" className={`${className} fill-none stroke-current stroke-[1.9]`}>
    <path d="M3 4h2l2 10h10l2-7H7" />
    <circle cx="10" cy="19" r="1.6" />
    <circle cx="17" cy="19" r="1.6" />
  </svg>
)

export default CartIcon
